// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "6363") return "6363.e7cb723d5.bundle.js";
  // return url for filenames based on template
  return "" + chunkId + ".e7cb723d5.chunk.js"
}